<common-top-tool-bar [title]="titleName+actionName"
                     [back]="backUrl"
                     [actionsTemplate]="actions">
  <ng-template #actions>
    <button nz-button [nzType]="'primary'" class="mr-4"
            [nzSize]="'large'" nzGhost
            [routerLink]="backUrl">
      取消
    </button>
    <button nz-button [nzType]="'primary'"
            [nzSize]="'large'"
            [disabled]="form.invalid || tabIndex==1"
            (click)="formElement.ngSubmit.emit()">
      {{this.item_id ? '保存' : '确定新增' }}
    </button>
  </ng-template>
</common-top-tool-bar>






<div class="page-tab-main v3">
  <nz-spin [nzSpinning]="isLoading">
  <nz-tabs nzLinkRouter nzType="card" (nzSelectedIndexChange)="tabIndexChange($event)" [nzSelectedIndex]="tabIndex">
    <nz-tab>
      <a *nzTabLink nz-tab-link [routerLink]="['.']" [queryParams]="{ tabIndex: '0' }" queryParamsHandling="merge">
        基本信息
      </a>
      <div class="page-main">
          <div class="page-main-wrapper" style="padding: 0 2rem;">
            <form nz-form #formElement="ngForm" [formGroup]="form" (ngSubmit)="submitForm($event, form.value )">
              <div nz-row nzGutter="36">
                <div nz-col nzSpan="12">
                  <nz-form-item>
                    <nz-form-label [nzSpan]="24" nzFor="name" nzRequired>输入{{titleName}}名称</nz-form-label>
                    <nz-form-control [nzSpan]="24" [nzErrorTip]="'请输入'+titleName+'名称'" >
                      <input nzSize="large" nz-input formControlName="name" id="name" [placeholder]="'请输入'+titleName+'名称'" />
                    </nz-form-control>
                  </nz-form-item >
                </div>
                <div nz-col nzSpan="12" class="text-right mt-4">
                </div>
                <div nz-col nzSpan="24">
                  <nz-form-item>
                    <nz-form-label [nzSpan]="24" nzFor="cover" nzRequired>上传封面图片</nz-form-label>
                    <nz-form-control [nzSpan]="24" nzHasFeedback [nzErrorTip]="'请上传封面图片'">
                      <div class="flex items-end">
                        <app-upload-image-with-preview-v2
                          [picPreview]="true"
                          [innerClass]=""
                          style="width: 180px;display: inline-block;"
                          [displayTextTemplate]="displayTextTemplate"
                          [displayIcon]="null"
                          [picUrl]="form.controls['cover'].value"
                          (imageUploaded)="setCover($event)"
                          previewClass="bg-cover bg-center"
                          [displayRatioWidth]="0"
                          [displayRatioHeight]="0">
                          <ng-template #displayTextTemplate>
                            <div class="p-6">请将文件拖曳至此或点击此处上传图片。</div>
                          </ng-template>
                        </app-upload-image-with-preview-v2>
                        <div class="font-light text-xs px-4">注：图片格式为 Jpg 或 Png 文件，图片文件大小限制为 2MB</div>
                        <input hidden nz-input formControlName="url">
                        <input hidden nz-input formControlName="school_id" [value]="user.school_id">
                      </div>
                    </nz-form-control>
                  </nz-form-item >
                </div>

                <div nz-col nzSpan="24" *ngIf="bisType == 'audio'">
                  <nz-form-item>
                    <nz-form-label [nzSpan]="24" nzFor="cover" nzRequired>上传音频</nz-form-label>
                    <nz-form-control [nzSpan]="24" nzHasFeedback [nzErrorTip]="'请上传音频'">
                      <div class="flex items-end">
                        <tw-audio-uploader
                          [audioUrl]="(form.controls['url'].value | mediaUrlPipe )"
                          comment="注：音频格式为 Mp3 文件，音频文件大小限制为 10MB。"
                          (clear)="clearAudio($event)"
                          [error]="audioErrorMessage"
                          (audioUploadFailure)="onAudioUploadFailure($event)"
                          (audioUploaded)="onAudioUploadSuccess($event)">
                        </tw-audio-uploader>
                        <input hidden nz-input formControlName="url">
                      </div>
                    </nz-form-control>
                  </nz-form-item >
                </div>
                <div nz-col nzSpan="24" *ngIf="bisType == 'video'">
                  <nz-form-item>
                    <nz-form-label [nzSpan]="24" nzFor="cover" nzRequired>上传视频</nz-form-label>
                    <nz-form-control [nzSpan]="24" nzHasFeedback [nzErrorTip]="'请上传视频'">
                      <div class="flex items-end">
                        <tw-video-uploader
                          [videoUrl]="(form.controls['url'].value | mediaUrlPipe )"
                          [limit]="500"
                          comment="注：视频格式为 Mp4 文件，音频文件大小限制为 500MB。"
                          (clear)="clearVideo($event)"
                          (videoUploadFailure)="onVideoUploadFailure($event)"
                          (videoCoverUploaded)="onVideoCoverUploadSuccess($event)"
                          (videoOverSize)="onVideoOverSize($event)"
                          (videoUploaded)="onVideoUploadSuccess($event)">
                        </tw-video-uploader>

                        <input hidden nz-input formControlName="url">
                      </div>
                    </nz-form-control>
                  </nz-form-item >
                </div>
              </div>
              <div nz-row nzGutter="36">

              </div>
              <div>
                <ng-container formArrayName="tagsGroupArray"
                              *ngFor="let tagGroupForm of tagsGroupArray.controls; let i = index;">
              <div [formGroupName]="i" style="background: #EEF5FF;" class="p-4 rounded-xl my-4 relative">
                <span nz-icon nzType="close-circle" nzTheme="fill"
                      style="z-index: 9999"
                      *ngIf="tagsGroupArray.controls.length > 1 && tagGroupForm.controls['tag_group_id.1'] == undefined"
                      (click)="removeTagsGroup(i)"
                      class="absolute text-lg right-2 top-0 cursor-pointer"></span>
                <div nz-row nzGutter="36" [hidden]="parseInt(tagGroupForm.controls.syllabus_id.value) === 0" >
                  <div nz-col nzSpan="12" >
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24" nzFor="syllabus_id" nzRequired>选择分类</nz-form-label>
                      <nz-form-control [nzSpan]="24" nzErrorTip="请选择分类">
                        <nz-select nzSize="large" nzAllowClear
                                   [formControlName]="'syllabus_id'" nzPlaceHolder="选择分类">
                          <nz-option [nzValue]="+item['id']" [nzLabel]="item['name']" *ngFor="let item of bookAttrs.syllabus"></nz-option>
                        </nz-select>
                      </nz-form-control>
                    </nz-form-item >
                  </div>
                  <div nz-col nzSpan="12"  [hidden]="parseInt(tagGroupForm.controls.course_id.value) === 0">
                    <nz-form-item>
                      <nz-form-label [nzSpan]="24" nzFor="course_id" nzRequired>选择大纲</nz-form-label>
                      <nz-form-control [nzSpan]="24" nzErrorTip="请选择大纲">
                        <nz-select nzSize="large" nzAllowClear
                                   [formControlName]="'course_id'"
                                   nzPlaceHolder="选择大纲">
                          <nz-option [nzValue]="+item['id']" [nzLabel]="item['name']"
                                     *ngFor="let item of currentSubOptions(i)"></nz-option>
                        </nz-select>
                      </nz-form-control>
                    </nz-form-item >
                  </div>

                  <!-- 从第三级开始的多级syllabus选择器 -->
                  <ng-container *ngIf="(bisType == 'audio' || bisType == 'video') && multiLevelSyllabusFilters && multiLevelSyllabusFilters.length > 0 && tagsGroupArray && tagsGroupArray.controls && tagsGroupArray.controls[i]">
                    <ng-container *ngFor="let levelConfig of multiLevelSyllabusFilters; let levelIndex = index">
                      <div nz-col nzSpan="12" *ngIf="shouldShowLevelSelector(i, levelConfig.level)">
                      <nz-form-item>
                        <nz-form-label [nzSpan]="24" [nzFor]="'level_' + levelConfig.level" nzRequired>{{levelConfig.name}}</nz-form-label>
                        <nz-form-control [nzSpan]="24" [nzErrorTip]="'请选择' + levelConfig.name">
                          <nz-select nzSize="large" nzAllowClear
                                     [formControlName]="'level_' + levelConfig.level"
                                     [nzPlaceHolder]="levelConfig.placeholder">
                            <nz-option [nzValue]="item['id']" [nzLabel]="item['name']"
                                       *ngFor="let item of getMultiLevelSyllabusOptions(i, levelConfig.level)"></nz-option>
                          </nz-select>
                        </nz-form-control>
                      </nz-form-item>
                    </div>
                    </ng-container>
                  </ng-container>
                </div>
                <div nz-row nzGutter="36" >
                  <div  nz-col nzSpan="12"
                        *ngFor="let syllabusTag of (rootThemesKeyValueItems[tagGroupForm.controls['syllabus_id'].value] || []); let tagIndex = index">
                    <nz-form-item >
                      <nz-form-label [nzSpan]="24" [nzFor]="'tag_group_id.'+syllabusTag.id">选择{{syllabusTag.name}}</nz-form-label>
                      <nz-form-control [nzSpan]="24"  [nzErrorTip]="'请选择'+syllabusTag.name">
                        <nz-select nzSize="large" nzAllowClear
                                   [formControlName]="'tag_group_id.' + syllabusTag.id"
                                   [nzPlaceHolder]="syllabusTag.name" nzMode="multiple">
                          <nz-option [nzValue]="item['id']"
                                     [nzLabel]="item['name']"
                                     *ngFor="let item of syllabusTag.children"></nz-option>
                        </nz-select>
                      </nz-form-control>
                    </nz-form-item >
                  </div>
                </div>
                <div nz-row nzGutter="36">

                  <!-- <div  nz-col nzSpan="12"
                        *ngFor="let themeControl of (rootThemesKeyValueItems[tagGroupForm.controls['course_id'].value]); let themeIndex = index">
                    <nz-form-item >
                      <nz-form-label [nzSpan]="24" [nzFor]="'tag_id.'+themeControl.id">选择{{themeControl.name}}</nz-form-label>
                      <nz-form-control [nzSpan]="24"  [nzErrorTip]="'请选择'+themeControl.name">
                        <nz-select nzSize="large" nzAllowClear
                                   [formControlName]="'tag_id.' + themeControl.id"
                                   [nzPlaceHolder]="themeControl.name" nzMode="multiple">
                          <nz-option [nzValue]="item['id']"
                                     [nzLabel]="item['name']"
                                     *ngFor="let item of themeControl.children"></nz-option>
                        </nz-select>
                      </nz-form-control>
                    </nz-form-item >
                  </div> -->

                </div>

              </div>
                </ng-container>
              </div>
              <div class="text-right my-4">
                <a nz-button nzBlock [nzType]="'text'" class="mr-4"
                   (click)="addTagsGroup({syllabus_id: -1, course_id: -1})"
                   style="color: #40a9ff;border-color: #40a9ff;"
                        [nzSize]="'default'"  nzGhost>
                  添加归属分类
                </a>
              </div>

            </form>
          </div>


      </div>
    </nz-tab>
        <nz-tab *ngIf="bisType == 'cartoon' || bisType == 'book'" [nzDisabled]="!Boolean(item_id)">
          <a *nzTabLink nz-tab-link [routerLink]="['.']" [queryParams]="{ tabIndex: '1' }" queryParamsHandling="merge">
            上传素材
          </a>
          <div class="page-main">
            <div class="page-main-table p-8">
              <div class="table-header"></div>
              <div nz-row nzGutter="32" *ngIf="items_status">
                <div nz-col nzSpan="12">
                  <book-rel-item-bar icon="reading" title="Reading"
                                 [status]="items_status.reading"
                                 [link]="'/admin/v3/resource/'+this.bisType+'/edit/'+this.item_id+'/reading'"></book-rel-item-bar>
                </div>
<!--                <div nz-col nzSpan="12">-->
<!--                  <book-rel-item-bar  icon="reading2" title="Recording"-->
<!--                                 [status]="items_status.recording"-->
<!--                                 [link]="'/admin/v3/resource/'+this.bisType+'/edit/'+this.item_id+'/reading'"-->
<!--                                 *ngIf="items_status && items_status.recording"></book-rel-item-bar>-->
<!--                  <book-rel-item-bar icon="reading2" title="Recording"-->
<!--                                 *ngIf="items_status && !items_status.recording"-->
<!--                                 (click)="noticeReadingStatus()"></book-rel-item-bar>-->
<!--                </div>-->
                <div nz-col nzSpan="12">
                  <book-rel-item-bar  icon="reading2" title="Touch To Read - 点读"
                                      [status]="items_status.touchToRead"
                                      [link]="'/admin/v3/resource/'+this.bisType+'/edit/'+this.item_id+'/touch-to-read'"
                                      *ngIf="items_status && items_status.reading"></book-rel-item-bar>
                  <book-rel-item-bar icon="reading2" title="Touch To Read - 点读"
                                     *ngIf="items_status && !items_status.reading"
                                     (click)="noticeReadingStatus()"></book-rel-item-bar>
                </div>

                <div nz-col nzSpan="12">
                  <book-rel-item-bar icon="listen" title="Listening"
                                     [status]="items_status.listening"
                                     [link]="'/admin/v3/resource/'+bisType+'/edit/'+this.item_id+'/audio'">

                  </book-rel-item-bar>
                </div>
                <div nz-col nzSpan="12">
                  <book-rel-item-bar icon="watching" title="Watching"
                                     [status]="items_status.watching"
                                     [link]="'/admin/v3/resource/'+bisType+'/edit/'+this.item_id+'/video'">

                  </book-rel-item-bar>
                </div>
                <div nz-col nzSpan="12">
                  <book-rel-item-bar icon="testing" title="Quiz"
                                     [link]="'/admin/v3/resource/'+bisType+'/edit/'+this.item_id+'/quiz'"
                  ></book-rel-item-bar>
                </div>

<!--                <div nz-col nzSpan="12">-->
<!--                  <book-rel-item-bar icon="vocabulary" title="Vocabulary"></book-rel-item-bar>-->
<!--                </div>-->
<!--                <div nz-col nzSpan="12">-->
<!--                  <book-rel-item-bar icon="sentence" title="Sentence"></book-rel-item-bar>-->
<!--                </div>-->
                <div nz-col nzSpan="12">
                  <book-rel-item-bar icon="dubbing" title="趣配音"></book-rel-item-bar>
                </div>

                <div nz-col nzSpan="12" *ngIf="bisType == 'book'">
                  <book-rel-item-bar icon="oid-pen"
                                     [link]="'/admin/v3/resource/'+bisType+'/edit/'+this.item_id+'/oid-package'"
                                     title="点读包"></book-rel-item-bar>
                </div>

                <div nz-col nzSpan="12" *ngIf="bisType == 'book'">
                  <book-rel-item-bar icon="ai-speaking"
                                     [status]="items_status.ai_speaking_topics"
                                     [link]="'/admin/v3/resource/'+bisType+'/edit/'+this.item_id+'/ai-speaking-topics'"
                                     title="AI口语话题"></book-rel-item-bar>
                </div>



<!--                <div nz-col nzSpan="12">-->
<!--                  <book-rel-item-bar icon="game" title="Game"></book-rel-item-bar>-->
<!--                </div>-->
<!--                <div nz-col nzSpan="12">-->
<!--                  <book-rel-item-bar icon="bandu" title="動畫伴讀"></book-rel-item-bar>-->
<!--                </div>-->
              </div>



            </div>
          </div>
        </nz-tab>
    <nz-tab *ngIf="bisType == 'exercise'" [nzDisabled]="!Boolean(item_id)">
      <a *nzTabLink nz-tab-link [routerLink]="['.']" [queryParams]="{ tabIndex: '1' }" queryParamsHandling="merge">
        配置习题
      </a>
      <book-exercise-tab
        (refresh)="reloadData()"
        [school_id]="user.school_id"
        [exercise_items]="exercise_items"></book-exercise-tab>
      <!--
      <div class="page-main">
        <div class="page-main-header">
          <div class="page-main-header-tools">
            <button nz-button nzType="primary" nzGhost (click)="showAudioResourceDialog()">
              <i nz-icon nzType="plus" nzTheme="outline" class="fix-icon" ></i>
              添加习题
            </button>
          </div>
          <div class="page-main-header-actions">
          </div>
        </div>
        <div class="page-main-wrapper" style="padding: 0 2rem;">


        </div>
      </div>
      -->
    </nz-tab>
  </nz-tabs>
  </nz-spin>
</div>

